"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendCuratePostApi = exports.sendEngagementReport = exports.sendUpVoteToPostComment = exports.sendReportToPostComment = exports.sendUpdateToPostComment = exports.sendReplyToPostComment = exports.sendComment = exports.sendPostRating = exports.getPostRating = exports.getPostInfoBySlug = exports.getPostComments = exports.getAuthorPost = exports.getPostInfo = exports.reportArticle = exports.getPostPaid = exports.getPostCost = exports.sendPrerender = exports.getPrerender = void 0;
var axios_1 = __importDefault(require("axios"));
var catchAxiosError_1 = __importDefault(require("../util/catchAxiosError"));
function getPrerender(url) {
    return axios_1.default.post("https://api.prerender.io/search", {
        prerenderToken: 'tC6wrR9xZAGGXIKzSDFU',
        query: url,
        start: 0
    });
}
exports.getPrerender = getPrerender;
function sendPrerender(url) {
    return axios_1.default.post("https://api.prerender.io/recache", {
        prerenderToken: 'tC6wrR9xZAGGXIKzSDFU',
        url: url
    });
}
exports.sendPrerender = sendPrerender;
function getPostCost() {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1.default.get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/postcost"))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getPostCost = getPostCost;
function getPostPaid(id) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1.default.get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/postpaid/").concat(id))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
exports.getPostPaid = getPostPaid;
function reportArticle(_a) {
    var payload = _a.payload;
    return __awaiter(this, void 0, void 0, function () {
        var id, token, reason, source;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    id = payload.id, token = payload.token, reason = payload.reason, source = payload.source;
                    return [4 /*yield*/, axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/report/post/").concat(id), { token: token, reason: reason, source: source })
                            .catch(catchAxiosError_1.default)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.reportArticle = reportArticle;
function getPostInfo(payload) {
    var token = payload.token, id = payload.id;
    return token
        ? axios_1.default
            .get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/posts/").concat(id, "?_embed"), { headers: { Authorization: 'Bearer ' + token } })
            .catch(catchAxiosError_1.default)
        : axios_1.default
            .get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/posts/").concat(id, "?_embed"))
            .catch(catchAxiosError_1.default);
}
exports.getPostInfo = getPostInfo;
function getAuthorPost(payload) {
    var token = payload.token, author_id = payload.author_id, post = payload.post;
    return token
        ? axios_1.default
            .get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/posts/?author=").concat(author_id, "&page=1&per_page=2&exclude=").concat(post, "&_embed"), { headers: { Authorization: 'Bearer ' + token } })
            .catch(catchAxiosError_1.default)
        : axios_1.default
            .get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/posts/?author=").concat(author_id, "&page=1&per_page=2&exclude=").concat(post, "&_embed"))
            .catch(catchAxiosError_1.default);
}
exports.getAuthorPost = getAuthorPost;
function getPostComments(payload) {
    //console.log(payload)
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/comments?post=").concat(payload.post, "&page=").concat(payload.page), {
        token: payload.token
    })
        .catch(catchAxiosError_1.default);
}
exports.getPostComments = getPostComments;
function getPostInfoBySlug(payload) {
    var id = payload.id;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/get/slug"), { id: id })
        .catch(catchAxiosError_1.default);
}
exports.getPostInfoBySlug = getPostInfoBySlug;
function getPostRating(payload) {
    var userId = payload.userId, id = payload.id;
    return userId
        ? axios_1.default
            .get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/get-post-rating/").concat(id, "?userId=").concat(userId))
            .catch(catchAxiosError_1.default)
        : axios_1.default
            .get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/get-post-rating/").concat(id))
            .catch(catchAxiosError_1.default);
}
exports.getPostRating = getPostRating;
function sendPostRating(payload) {
    var token = payload.token, id = payload.id, rating = payload.rating, authorId = payload.authorId, userId = payload.userId, target = payload.target, articleName = payload.articleName;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/rate-post"), {
        token: token,
        id: id,
        rating: rating,
        authorId: authorId,
        userId: userId,
        target: target,
        articleName: articleName
    })
        .catch(catchAxiosError_1.default);
}
exports.sendPostRating = sendPostRating;
function sendComment(_a) {
    var id = _a.id, text = _a.text, token = _a.token, authorId = _a.authorId, userId = _a.userId, target = _a.target, articleName = _a.articleName;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/new-comment"), {
        token: token,
        post: id,
        content: text,
        authorId: authorId,
        userId: userId,
        target: target,
        articleName: articleName
    })
        .catch(catchAxiosError_1.default);
}
exports.sendComment = sendComment;
function sendReplyToPostComment(_a) {
    var token = _a.token, id = _a.id, parent = _a.parent, text = _a.text, authorId = _a.authorId, userId = _a.userId, target = _a.target, replyId = _a.replyId, articleName = _a.articleName;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/new-comment-reply"), {
        token: token,
        post: id,
        content: text,
        parent: parent,
        authorId: authorId,
        userId: userId,
        replyId: replyId,
        target: target,
        articleName: articleName
    })
        .catch(catchAxiosError_1.default);
}
exports.sendReplyToPostComment = sendReplyToPostComment;
function sendUpdateToPostComment(_a) {
    var token = _a.token, post = _a.post, commentId = _a.commentId, text = _a.text, authorId = _a.authorId, userId = _a.userId, target = _a.target, articleName = _a.articleName;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/update-comment"), {
        token: token,
        post: post,
        content: text,
        commentId: commentId,
        authorId: authorId,
        userId: userId,
        target: target,
        articleName: articleName
    })
        .catch(catchAxiosError_1.default);
}
exports.sendUpdateToPostComment = sendUpdateToPostComment;
function sendReportToPostComment(_a) {
    var token = _a.token, post = _a.post, commentId = _a.commentId, userId = _a.userId, target = _a.target, articleName = _a.articleName;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/report-comment"), {
        token: token,
        post: post,
        commentId: commentId,
        userId: userId,
        target: target,
        articleName: articleName
    })
        .catch(catchAxiosError_1.default);
}
exports.sendReportToPostComment = sendReportToPostComment;
function sendUpVoteToPostComment(_a) {
    var token = _a.token, post = _a.post, commentId = _a.commentId, userId = _a.userId, target = _a.target, comment_user_id = _a.comment_user_id, articleName = _a.articleName;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/upvote-comment"), {
        token: token,
        post: post,
        commentId: commentId,
        userId: userId,
        target: target,
        comment_user_id: comment_user_id,
        articleName: articleName
    })
        .catch(catchAxiosError_1.default);
}
exports.sendUpVoteToPostComment = sendUpVoteToPostComment;
function sendEngagementReport(_a) {
    var token = _a.token, data = _a.data;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/save-engagement"), {
        token: token,
        data: data
    })
        .catch(catchAxiosError_1.default);
}
exports.sendEngagementReport = sendEngagementReport;
function sendCuratePostApi(payload) {
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/curate-post"), payload)
        .catch(catchAxiosError_1.default);
}
exports.sendCuratePostApi = sendCuratePostApi;
